module.exports = __webpack_public_path__ + "static/bam-3bad113e220e8585d1d5024ce82e0060.jpg";